import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import * as SettingsActions from '../../../state/actions/message-settings'
import NewAppointmentMessage from './NewAppointmentMessage'
import Help from '../Help'
import HelpButton from '../HelpButton'
import buildTextEditor from '../buildTextEditor'
import { logException } from '../../../services/sentry'
import styles from './styles.css'

const NewAppointmentEmail = buildTextEditor(NewAppointmentMessage)
const NewAppointmentText = buildTextEditor(NewAppointmentMessage)

class NewAppointmentMessageEditor extends React.Component {
  static propTypes = {
    activateSetting: PropTypes.func,
    createMessageSetting: PropTypes.func,
    deactivateSetting: PropTypes.func,
    hasPlum: PropTypes.bool,
    maxChars: PropTypes.number.isRequired,
    newApptEmail: PropTypes.shape({
      active: PropTypes.bool.isRequired,
      always_send: PropTypes.bool.isRequired,
      created_at: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      message_setting_type: PropTypes.string.isRequired,
      message_type: PropTypes.string.isRequired,
      offset: PropTypes.number.isRequired,
      practice_id: PropTypes.number.isRequired,
      updated_at: PropTypes.string.isRequired,
    }),
    newApptText: PropTypes.shape({
      active: PropTypes.bool.isRequired,
      always_send: PropTypes.bool.isRequired,
      created_at: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      message_setting_type: PropTypes.string.isRequired,
      message_type: PropTypes.string.isRequired,
      offset: PropTypes.number.isRequired,
      practice_id: PropTypes.number.isRequired,
      updated_at: PropTypes.string.isRequired,
    }),
    pmsType: PropTypes.string,
    pmsVersion: PropTypes.number,
    updateMessageSetting: PropTypes.func,
  }
  constructor(props) {
    super(props)
    this.state = {
      isHelpOpen: false,
    }
  }

  toggleHelp = () => {
    this.setState({ isHelpOpen: !this.state.isHelpOpen })
  }

  updateSetting = ({ body, subject, always_send }) => {
    const { newApptEmail, newApptText } = this.props
    const settingId = subject ? newApptEmail.id : newApptText.id
    const changes = {
      body,
      subject,
      always_send,
    }

    return this.props
      .updateMessageSetting(settingId, changes)
      .then(() => {
        // deactivate message setting if left empty
        if (!body.text.trim()) {
          this.props.deactivateSetting(settingId)
        }
      })
      .catch((err) => {
        logException(err)
      })
  }

  createNewAppointmentText = ({ body, subject, always_send }) => {
    if (body.text.trim()) {
      const initialSetting = {
        active: !!body,
        always_send: false,
        body: '',
        message_type: 'text',
        message_setting_type: 'new_appt',
      }
      const changes = {
        body,
        subject,
        always_send,
        offset: 1,
      }
      return this.props
        .createMessageSetting(initialSetting, changes)
        .catch((err) => {
          console.error(err)
        })
    }
    return Promise.resolve('emptyText')
  }

  render() {
    const { isHelpOpen } = this.state
    const {
      activateSetting,
      deactivateSetting,
      hasPlum,
      maxChars,
      newApptEmail,
      newApptText,
      pmsType,
      pmsVersion,
    } = this.props

    return (
      <div className={`${styles.container} CallTextSettingEditor`}>
        <h1>New Appointment Messaging</h1>
        <div className="helpButtonContainer">
          <HelpButton onTouchTap={this.toggleHelp} />
        </div>
        {isHelpOpen && (
          <Help
            hasPlum={!!hasPlum}
            hasReviews={false}
            onlyVars
            pmsType={pmsType}
            pmsVersion={pmsVersion}
          />
        )}
        <div className={styles.newApptMessagesWrapper}>
          {newApptEmail && (
            <NewAppointmentEmail
              key={newApptEmail.id}
              hasPlum={false}
              hasReviews={false}
              isEmail
              maxChars={maxChars}
              pmsType={pmsType}
              pmsVersion={pmsVersion}
              setting={newApptEmail}
              title="New Appointment Email"
              updateSetting={this.updateSetting}
              activateSetting={activateSetting}
              deactivateSetting={deactivateSetting}
            />
          )}
          {newApptText && (
            <NewAppointmentText
              key={newApptText.id}
              createSetting={this.createNewAppointmentText}
              hasPlum={false}
              hasReviews={false}
              maxChars={maxChars}
              pmsType={pmsType}
              pmsVersion={pmsVersion}
              setting={newApptText}
              title="New Appointment Text"
              updateSetting={this.updateSetting}
              activateSetting={activateSetting}
              deactivateSetting={deactivateSetting}
            />
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({
  account: {
    auth: { hasPlum, pmsType, pmsVersion },
  },
}) => ({
  hasPlum,
  pmsType,
  pmsVersion,
})

const mapDispatchToProps = {
  updateMessageSetting: SettingsActions.updateMessageSetting,
  createMessageSetting: SettingsActions.createMessageSetting,
  activateSetting: SettingsActions.activateSetting,
  deactivateSetting: SettingsActions.deactivateSetting,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewAppointmentMessageEditor)



// WEBPACK FOOTER //
// ./src/components/Settings/NewAppointmentMessageEditor/index.js